export default "__VITE_PUBLIC_ASSET__a57e2354__"